import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Text — a semantic inline or block text container.
 * Defaults to <span>; use as="p" for paragraphs.
 * No styles are added — className is forwarded directly.
 *
 * @atomic-tier Atom
 * @category Typography
 */

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
  /** The HTML element to render. Defaults to `span`. */
  as?: React.ElementType
}

const Text = React.forwardRef<HTMLElement, TextProps>(
  ({ as: Component = 'span', className, children, ...props }, ref) => (
    <Component
      ref={ref}
      className={cn(className)}
      {...props}
    >
      {children}
    </Component>
  ),
)
Text.displayName = "Text"

export { Text }
